import React, { useState, useCallback } from 'react';
import { Plus, RefreshCw, TestTube2, Loader2 } from 'lucide-react';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import SettingsLayout from '../../../components/Admin/Settings/SettingsLayout';
import PrinterConfigurations from '../../../components/Admin/Settings/PrinterConfigurations';

/**
 * Printer Configuration Settings Page
 *
 * Configure thermal printers for bills, KOT, and kitchen stations.
 * Action buttons are rendered in the sticky header.
 */
export default function PrinterConfigPage() {
  const [componentActions, setComponentActions] = useState(null);

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  // Action buttons for the header
  const headerActions = componentActions ? (
    <>
      {/* Test Print Buttons */}
      <button
        onClick={componentActions.onTestBill}
        disabled={componentActions.testingPrinter === "BILL"}
        className="px-2.5 py-1.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 flex items-center gap-1.5 text-xs font-medium border border-blue-200 disabled:opacity-50"
      >
        {componentActions.testingPrinter === "BILL" ? (
          <Loader2 size={14} className="animate-spin" />
        ) : (
          <TestTube2 size={14} />
        )}
        Test Bill
      </button>
      <button
        onClick={componentActions.onTestKOT}
        disabled={componentActions.testingPrinter === "KOT"}
        className="px-2.5 py-1.5 bg-amber-50 text-amber-700 rounded-lg hover:bg-amber-100 flex items-center gap-1.5 text-xs font-medium border border-amber-200 disabled:opacity-50"
      >
        {componentActions.testingPrinter === "KOT" ? (
          <Loader2 size={14} className="animate-spin" />
        ) : (
          <TestTube2 size={14} />
        )}
        Test KOT
      </button>

      <div className="h-5 w-px bg-slate-200" />

      <button
        onClick={componentActions.onAdd}
        className="px-3 py-1.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-1.5 text-sm font-medium"
      >
        <Plus size={16} />
        Add Printer
      </button>
      <button
        onClick={componentActions.onRefresh}
        className="p-1.5 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 border border-slate-200"
      >
        <RefreshCw size={16} />
      </button>
    </>
  ) : null;

  return (
    <AdminLayout>
      <SettingsLayout actions={headerActions}>
        <PrinterConfigurations renderActions={handleActionsReady} />
      </SettingsLayout>
    </AdminLayout>
  );
}
